// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore"
import { getStorage } from 'firebase/storage';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCd6lAM-vDjeRd916DBZgyaPfK1XBkduFw",
  authDomain: "bouwruimte-13db3.firebaseapp.com",
  projectId: "bouwruimte-13db3",
  storageBucket: "bouwruimte-13db3.appspot.com",
  messagingSenderId: "362992070595",
  appId: "1:362992070595:web:f559565a0562ef63fc5776",
  measurementId: "G-8ZMHX4JSZQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const db = getFirestore()
const projectStorage = getStorage();
export {db, projectStorage}